<template>
  <v-container class="pa-0">
      <v-skeleton-loader v-if="isLoading" type="card" class="mx-auto" max-width="90%"/>

    <v-form v-if="!isLoading" ref="step9form">

      <v-row>

        <v-col cols="12" md="8">
                <h3>Confirmar subsanación</h3>
                <p>Por favor lee completamente el resumen de tu solicitud y pulsa en 'Confirmar subsanación' para recibir por SMS el código de confirmación.</p>
        </v-col>

         <v-col cols="12" md="4">
                <v-btn color="primary" v-bind:disabled="!pdfCargado" style="float:right" class="btn-next mt-md-3" @click="$refs.FirmarDialog.open()" >Confirmar subsanación</v-btn>
         </v-col>

        <v-col cols="12" lg="10" md="11" class="mx-auto" style="min-height:520px;">
         <iframe width="100%" ref="pdfIframe" height="100%" style="border:0;" />
        </v-col>
    </v-row>

    <v-row  cols="11" class="mt-8 mb-4">

      <v-col cols="12" md="6" >
        <v-btn class="btn-prev"
          @click="continuePrev"
          color="umivalesecondary">Anterior
        </v-btn>
      </v-col>

      <v-col cols="12" md="6">
        <FirmarDialog style="float:right;" ref='FirmarDialog'
            v-on:firmada="continueNext" v-bind:habilitado="pdfCargado"
            v-bind:idFirmaDocumento="idFirmaDocumento" 
						@alert-event="event => $emit('alert-event', event)"/>
      </v-col>
    </v-row>
    </v-form>

    </v-container>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { privateServiceURL } from '@Base/plugins/axios.js';
import api from '@Base/services/auditoriaService'
//import apiSolicitud from '@Base/services/solicitudService'
import StepBase from './common/StepBase'
import FirmarDialog from './common/FirmarDialog'
//import NavigationUtils from './common/NavigationUtils'

  export default {
      name: 'ConfirmarSubsanacionMain',
      mixins: [StepBase],
      components: {
        FirmarDialog
      },
     data () {
      return {
       isLoading: false,
       idFirmaDocumento:null,
       solicitante: null
      }
    },
    methods: {
      continuePrev: function() {
				this.$router.push({ name: 'declaraciones', params: {id: this.$store.state.solicitud.tokenAcceso, notificacion: this.$store.state.solicitud.idNotificacion} });
      },
      continueNext: function() {
        if (!this.$refs.step9form.validate()) {
          return;
        }

        this.isLoading = true;

        api.putConfirmarSubsanacion(
          res => {
            this.isLoading=false;
						this.$router.push({ name: 'descargar-documentacion', params: { id: this.solicitante.token } });
						//window.open(res, "_self");
          },
          error => {
						this.isLoading = false;
						this.$emit('alert-event', { text: 'Error al enviar confirmación de solicitud', color: 'red' });
						console.log(error);
          }
        );
      },
      // eslint-disable-next-line no-unused-vars
      loadSolicitante: function (vm,params) {
        vm.$refs.step9form.resetValidation();
        //if (!this.handleStepEntry(params.id)) return;

        this.isLoading = true;
        this.tokenGestion=this.$store.state.solicitud.tokenGestion;
        api.getDeclaracionResponsable(this.notificacionOrigen,
          data => {
            this.isLoading = false;
            this.solicitante=data.solicitante;
            this.idFirmaDocumento=data.idFirmaDocumento;
            this.loadReport();
          },
          error => {
						this.isLoading = false;
						this.$emit('alert-event', { text: 'Error al cargar la declaración responsable', color: 'red' });
						console.log(error);
          }
        );
      },
      loadReport: function () {
        const me = this;

        setTimeout( function () {
					const baseServiceUrl = privateServiceURL.substring(0, privateServiceURL.indexOf('/private/') + 1);
          me.$refs.pdfIframe.src = `${baseServiceUrl}pdf/web/viewer2b.html?file=${baseServiceUrl}private/auditoria/confirmar-subsanacion/${me.solicitante.idSolicitante}/preview/${me.solicitante.tokenRedireccion}/${me.notificacionOrigen}`;
          me.$store.commit('solicitud/setPdfCompletado',false);
          me.$store.commit('solicitud/setPdfCargado',false);
          }, 100);
      }
  },
  computed: {
    pdfCompletado () {
      return this.$store.state.solicitud.pdfCompletado;
    },
    pdfCargado () {
      return this.$store.state.solicitud.pdfCargado;
    },
    notificacionOrigen(){
      return  this.$store.state.solicitud.idNotificacion;
    }
  },
    watch: {
        // eslint-disable-next-line no-unused-vars
        $route(to, from) {
					this.loadSolicitante(this,to.params);
        },
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.loadSolicitante(vm, to.params);
      })
    }
  }
</script>